import { Switch, Route } from 'react-router-dom';
import { Trans } from '@lingui/react/macro';

import LoginContainer from 'containers/Login/LoginContainer';
import LoginForm from 'containers/Login/LoginForm';
import RecoveryForm from 'containers/Login/RecoveryForm';
import RecoveryWithCode from 'containers/Login/RecoveryWithCode';
import RecoveryEmailSent from 'containers/Login/RecoveryEmailSent';

import { userContext } from 'contexts/UserContext';

import { config, SUPPORT_LINKS } from 'config';

import { Footer, MAX_COUNTRIES } from 'ui-kit/Footer';
import { useContext } from 'react';
import { Faq } from 'newComponents/Faq';
import { UserLoyaltyBalance } from 'components/UserLoyaltyBalance';
import { LowBalanceNotification } from 'containers/LowBalanceNotification';

import { useBrandFeatures } from 'hooks/useBrandFeatures';
import { KZAd } from 'components/KZAd';
import { DemoAccessUi, isDemoAccess } from 'features/demoAccess';
import { openFeatureFlagModal } from 'features/flags';
import { useTouchAndHold } from 'hooks/useTouchAndHold';
import { useBooleanState } from 'hooks/useBooleanState';
import { BYNotification } from 'components/BYNotification';
import Routes from './Routes';
import Header from './Header';

import styles from './Main.module.scss';
import { useOmni } from './useOmni';
import { useChaport } from './useChaport';

function Main() {
  const { user } = useContext(userContext);
  const features = useBrandFeatures();
  useOmni();
  useChaport();
  const ref = useTouchAndHold(openFeatureFlagModal, 3_000);

  const [isBYModalShown, showBYModal, hideBYModal] = useBooleanState(false);

  if (!user) {
    return (
      <LoginContainer>
        <Switch>
          {config.KEYCLOAK_AUTH && (
            <Route
              exact
              path="/recovery/email-sent"
              component={RecoveryEmailSent}
            />
          )}
          <Route exact path="/recovery/code" component={RecoveryWithCode} />
          <Route exact path="/recovery" component={RecoveryForm} />
          <Route>
            <LoginForm onLogin={showBYModal} />
          </Route>
        </Switch>
      </LoginContainer>
    );
  }

  return (
    <main className={styles.main}>
      <Header />
      {features.faq && <Faq />}
      {features.shop && <UserLoyaltyBalance />}
      <LowBalanceNotification />
      <div className={styles.container}>
        {isDemoAccess() && <DemoAccessUi.DemoAccessHint />}
        <Routes />
      </div>
      <Footer
        version={<span ref={ref}>{config.npm_package_version}</span>}
        phone={features.supportInfo ? SUPPORT_LINKS.Tell : undefined}
        tg={features.supportInfo ? SUPPORT_LINKS.TG : undefined}
        max={
          user.Groups.some((group) =>
            MAX_COUNTRIES.includes(group.Country.toLowerCase())
          )
            ? SUPPORT_LINKS.MAX
            : undefined
        }
        helpdeskInfo={
          features.supportInfo ? (
            <Trans>
              Техническая поддержка
              <br />с 07: 00 до 21: 00 МСК
            </Trans>
          ) : undefined
        }
      />
      <KZAd />
      <BYNotification visible={isBYModalShown} onHide={hideBYModal} />
    </main>
  );
}

export default Main;
